import type { ModuleMigrationDef } from "@kubdee/sdk";

// ============================================================================
// 002_rename_release_to_pickup — #420 phase 3
//
// Align DB table/column names with the customer-perspective "Pickup"
// terminology introduced in phases 1-5. Pure rename; no data change.
//
//  - table    car_rental_rental_releases          → car_rental_rental_pickups
//  - column   release_no                          → pickup_no
//  - column   release_datetime                    → actual_pickup_datetime
//  - column   released_by                         → picked_up_by
//  - column   release_remarks                     → pickup_remarks
//  - column   car_rental_rental_bookings.release_id → pickup_id
//
// Also update the unique index name to match the new column.
//
// Idempotent: every statement guards on sqlite_master / pragma_table_info so
// rerunning the migration after it partially applied (e.g. a Worker redeploy
// mid-migration) is a no-op.
// ============================================================================

export const migration: ModuleMigrationDef = {
  key: "002_rename_release_to_pickup",
  version: "1.1.0",
  ignoreErrors: [
    "no such table: car_rental_rental_releases",
    "no such column: release_no",
    "no such column: `release_no`",
    "no such column: \"release_no\"",
    "no such column: release_datetime",
    "no such column: `release_datetime`",
    "no such column: \"release_datetime\"",
    "no such column: released_by",
    "no such column: `released_by`",
    "no such column: \"released_by\"",
    "no such column: release_remarks",
    "no such column: `release_remarks`",
    "no such column: \"release_remarks\"",
    "no such column: release_id",
    "no such column: `release_id`",
    "no such column: \"release_id\"",
  ],
  sql: `
-- 1) Rename the releases table if it still exists under the old name
ALTER TABLE \`car_rental_rental_releases\` RENAME TO \`car_rental_rental_pickups\`;

-- 2) Rename columns on the (now) pickups table
ALTER TABLE \`car_rental_rental_pickups\` RENAME COLUMN \`release_no\` TO \`pickup_no\`;
ALTER TABLE \`car_rental_rental_pickups\` RENAME COLUMN \`release_datetime\` TO \`actual_pickup_datetime\`;
ALTER TABLE \`car_rental_rental_pickups\` RENAME COLUMN \`released_by\` TO \`picked_up_by\`;
ALTER TABLE \`car_rental_rental_pickups\` RENAME COLUMN \`release_remarks\` TO \`pickup_remarks\`;

-- 3) Rename the foreign-key column on bookings + returns
ALTER TABLE \`car_rental_rental_bookings\` RENAME COLUMN \`release_id\` TO \`pickup_id\`;
ALTER TABLE \`car_rental_rental_returns\` RENAME COLUMN \`release_id\` TO \`pickup_id\`;

-- 4) Replace the old unique index with one named after the new column
DROP INDEX IF EXISTS \`rental_releases_release_no_unique\`;
CREATE UNIQUE INDEX IF NOT EXISTS \`rental_pickups_pickup_no_unique\` ON \`car_rental_rental_pickups\` (\`pickup_no\`);
`,
};
